import React, { useState } from "react";
import emailjs from "emailjs-com";
import Modal from "./Modal";
import { useNavigate } from "react-router-dom";

const ConfirmationPage = ({ onNext, onBack, formData: initialFormData }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const selectedInsurance = initialFormData.selectedInsurance || {};

  const handleConfirm = () => {
    sendEmail();
  };

  const sendEmail = () => {
    const motorPowers = initialFormData.motorPower || [];
    const motorUnits = initialFormData.motorPowerUnit || [];
    const motorSerials = initialFormData.motorSerial || [];
    const motorTypes = initialFormData.motorType || [];
    const fuelTypes = initialFormData.fuelType || [];
    const motorBrands = initialFormData.motorBrand || [];

    // Motorinformatie formatteren (met merk + eenheid)
    const motorInfo = motorPowers
      .map((power, index) => {
        const brand = motorBrands[index] || "Niet ingevuld";
        const unit = motorUnits[index] || "PK";
        const serial = motorSerials[index] || "Niet ingevuld";
        const type = motorTypes[index] || "Niet ingevuld";
        const fuel = fuelTypes[index] || "Niet ingevuld";
        return `Motor ${index + 1}:
        - Merk: ${brand}
        - Vermogen: ${power} ${unit}
        - Serienummer: ${serial}
        - Motortype: ${type}
        - Brandstof: ${fuel}`;
      })
      .join("\n\n");

    // Schadegevallen formatteren
    const accidents = initialFormData.accidentDetails || [];
    const accidentInfo = accidents.length
      ? accidents
          .map(
            (accident, index) =>
              `Schadegeval ${index + 1}:
            - Naam vaartuig: ${accident.boatName || "Niet ingevuld"}
            - Datum: ${accident.date || "Niet ingevuld"}
            - Omstandigheden: ${accident.circumstances || "Niet ingevuld"}
            - Kosten: €${accident.costs || "Niet ingevuld"}`
          )
          .join("\n\n")
      : "Geen schadegevallen in de laatste 5 jaar.";

    const templateParams = {
      // Boot
      boatType: initialFormData.boatType || "Niet ingevuld",
      boatName: initialFormData.boatName || "Niet ingevuld", // nieuw
      boatLength: initialFormData.boatLength || "Niet ingevuld",
      countryFlag: initialFormData.countryFlag || "Niet ingevuld",
      boatLocation: initialFormData.boatLocation || "Niet ingevuld",
      boatRegion:
        (initialFormData.boatRegion && initialFormData.boatRegion.join(", ")) ||
        "Niet ingevuld",
      boatBrand: initialFormData.boatBrand || "Niet ingevuld",
      boatYear: initialFormData.boatYear || "Niet ingevuld",
      boatRegistrationNumber:
        initialFormData.boatRegistrationNumber || "Niet ingevuld",
      hullMaterial: initialFormData.hullMaterial || "Niet ingevuld", // nieuw

      motorCount: initialFormData.motorCount || "Niet ingevuld",
      motorInfo, // geformatteerde tekst
      motorPowerUnits:
        ((initialFormData.motorPowerUnit || []).length &&
          initialFormData.motorPowerUnit.join(", ")) ||
        "Niet ingevuld",
      motorBrands:
        ((initialFormData.motorBrand || []).length &&
          initialFormData.motorBrand.join(", ")) ||
        "Niet ingevuld",

      // Schade
      accidentInfo,

      // Eigenaar
      name: initialFormData.name || "Niet ingevuld",
      surname: initialFormData.surname || "Niet ingevuld",
      street: initialFormData.street || "Niet ingevuld",
      houseNumber: initialFormData.houseNumber || "Niet ingevuld",
      postalCode: initialFormData.postalCode || "Niet ingevuld",
      country: initialFormData.country || "Niet ingevuld",
      birthdate: initialFormData.birthdate || "Niet ingevuld",
      phoneNumber: initialFormData.phoneNumber || "Niet ingevuld",
      email: initialFormData.email || "Niet ingevuld",

      // Verzekeringen
      liability: selectedInsurance.liability ? "Ja" : "Nee",
      waterSkiing: selectedInsurance.waterSkiing ? "Ja" : "Nee",
      waterskiCapacity: selectedInsurance.waterSkiing
        ? selectedInsurance.waterskiCapacity || "Niet ingevuld"
        : "—", // nieuw

      casco: selectedInsurance.casco ? "Ja" : "Nee",
      cascoValue: selectedInsurance.casco
        ? selectedInsurance.cascoValue || "Niet ingevuld"
        : "—",

      trailerInsurance:
        selectedInsurance.casco && selectedInsurance.trailerInsurance
          ? "Ja"
          : selectedInsurance.casco
          ? "Nee"
          : "—", // nieuw
      trailerValue:
        selectedInsurance.casco && selectedInsurance.trailerInsurance
          ? selectedInsurance.trailerValue || "Niet ingevuld"
          : "—", // nieuw

      dinghyInsurance:
        selectedInsurance.casco && selectedInsurance.dinghyInsurance
          ? "Ja"
          : selectedInsurance.casco
          ? "Nee"
          : "—", // nieuw
      dinghyValue:
        selectedInsurance.casco && selectedInsurance.dinghyInsurance
          ? selectedInsurance.dinghyValue || "Niet ingevuld"
          : "—", // nieuw

      trackAndTrace: selectedInsurance.casco
        ? selectedInsurance.trackAndTrace
          ? "Ja"
          : "Nee"
        : "—", // nieuw

      rescueCosts: selectedInsurance.rescueCosts ? "Ja" : "Nee",
      rescueAmount: selectedInsurance.rescueCosts
        ? selectedInsurance.rescueAmount === "custom"
          ? "Op aanvraag"
          : selectedInsurance.rescueAmount || "Niet ingevuld"
        : "—",

      personalAccidents: selectedInsurance.personalAccidents ? "Ja" : "Nee",
      accidentPassengers: selectedInsurance.personalAccidents
        ? selectedInsurance.accidentPassengers || "Niet ingevuld"
        : "—",
      legalAssistance: selectedInsurance.legalAssistance ? "Ja" : "Nee",
    };

    emailjs
      .send(
        "service_o5939qw",
        "template_yjybnap",
        templateParams,
        "Mq0NNULbOl3aTvHgz"
      )
      .then(
        () => setShowModal(true),
        (error) => {
          console.error("Er is een fout opgetreden:", error);
          alert("Er ging iets mis bij het verzenden van de e-mail.");
        }
      );
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate("/");
  };

  const handleBack = () => {
    if (typeof onBack === "function") onBack(initialFormData);
  };

  const motorPowers = initialFormData.motorPower || [];
  const motorSerials = initialFormData.motorSerial || [];
  const motorBrands = initialFormData.motorBrand || [];
  const motorUnits = initialFormData.motorPowerUnit || [];
  const motorTypes = initialFormData.motorType || [];
  const fuelTypes = initialFormData.fuelType || [];

  return (
    <div className="p-8">
      <div className="mx-auto max-w-3xl p-6">
        <h1 className="text-3xl font-semibold mb-6 text-left text-[#1a2a6c]">
          Bevestig je gegevens
        </h1>
        <p className="text-lg font-medium text-[#1a2a6c] mb-6">
          Overloop nog even je gegevens zodat we voor jou aan de slag kunnen
          gaan. Een foutje gevonden? Geen probleem, je kan je gegevens nog
          wijzigen.
        </p>

        {/* Bootinformatie */}
        <div className="space-y-4 mb-8">
          <h2 className="text-xl font-semibold text-[#1a2a6c]">
            Bootinformatie
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
            <p>
              <strong>Boottype:</strong> {initialFormData.boatType}
            </p>
            <p>
              <strong>Naam van de boot:</strong>{" "}
              {initialFormData.boatName || "—"}
            </p>
            <p>
              <strong>Bootlengte:</strong> {initialFormData.boatLength} meter
            </p>
            <p>
              <strong>Land van registratie:</strong>{" "}
              {initialFormData.countryFlag}
            </p>
            <p>
              <strong>Registratienummer:</strong>{" "}
              {initialFormData.boatRegistrationNumber || "—"}
            </p>
            <p>
              <strong>Ligplaats:</strong> {initialFormData.boatLocation}
            </p>
            <p>
              <strong>Vaargebied:</strong>{" "}
              {(initialFormData.boatRegion || []).join(", ")}
            </p>
            <p>
              <strong>Merk:</strong> {initialFormData.boatBrand}
            </p>
            <p>
              <strong>Bouwjaar:</strong> {initialFormData.boatYear}
            </p>
            <p>
              <strong>Rompmateriaal:</strong>{" "}
              {initialFormData.hullMaterial || "—"}
            </p>
            <p>
              <strong>Aantal motoren:</strong> {initialFormData.motorCount}
            </p>

            {/* Motoren detailblokken */}
            {motorPowers.map((power, index) => (
              <div
                key={`motorblock-${index}`}
                className="col-span-1 sm:col-span-2 border rounded-md p-3 border-[#ff6f61]"
              >
                <p>
                  <strong>Motor {index + 1} merk:</strong>{" "}
                  {motorBrands[index] || "—"}
                </p>
                <p>
                  <strong>Motor {index + 1} vermogen:</strong> {power}{" "}
                  {motorUnits[index] || "PK"}
                </p>
                <p>
                  <strong>Motor {index + 1} serienummer:</strong>{" "}
                  {motorSerials[index] || "—"}
                </p>
                <p>
                  <strong>Motortype:</strong> {motorTypes[index] || "—"}
                </p>
                <p>
                  <strong>Brandstof:</strong> {fuelTypes[index] || "—"}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Eigenaarinformatie */}
        <div className="space-y-4 mb-8">
          <h2 className="text-xl font-semibold text-[#1a2a6c]">
            Eigenaarinformatie
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
            <p>
              <strong>Naam:</strong> {initialFormData.name}
            </p>
            <p>
              <strong>Voornaam:</strong> {initialFormData.surname}
            </p>
            <p>
              <strong>Straat:</strong> {initialFormData.street}
            </p>
            <p>
              <strong>Nummer:</strong> {initialFormData.houseNumber}
            </p>
            <p>
              <strong>Postcode:</strong> {initialFormData.postalCode}
            </p>
            <p>
              <strong>Land:</strong> {initialFormData.country}
            </p>
            <p>
              <strong>Geboortedatum:</strong> {initialFormData.birthdate}
            </p>
            <p>
              <strong>Telefoonnummer:</strong> {initialFormData.phoneNumber}
            </p>
            <p>
              <strong>Email:</strong> {initialFormData.email}
            </p>
            {initialFormData.isLegalEntity && (
              <p>
                <strong>Ondernemingsnummer:</strong>{" "}
                {initialFormData.enterpriseNumber}
              </p>
            )}
          </div>
        </div>

        {/* Schadegevallen */}
        {initialFormData.noAccidents &&
          (initialFormData.accidentDetails || []).length > 0 && (
            <div className="space-y-4 mb-8">
              <h2 className="text-xl font-semibold text-[#1a2a6c]">
                Schadegevallen
              </h2>
              {(initialFormData.accidentDetails || []).map(
                (accident, index) => (
                  <div
                    key={index}
                    className="border rounded-md p-4 border-[#ff6f61] space-y-2"
                  >
                    <p>
                      <strong>Naam vaartuig:</strong> {accident.boatName}
                    </p>
                    <p>
                      <strong>Datum van het ongeval:</strong> {accident.date}
                    </p>
                    <p>
                      <strong>Omstandigheden:</strong> {accident.circumstances}
                    </p>
                    <p>
                      <strong>Kosten:</strong> €{accident.costs}
                    </p>
                  </div>
                )
              )}
            </div>
          )}

        {/* Verzekeringsopties */}
        <div className="space-y-4 mb-8">
          <h2 className="text-xl font-semibold text-[#1a2a6c]">
            Verzekeringsopties
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-6">
            <p>
              <strong>Burgerlijke aansprakelijkheid:</strong>{" "}
              {selectedInsurance.liability ? "Ja" : "Nee"}
            </p>

            {/* Lichtingskosten */}
            {selectedInsurance.rescueCosts && (
              <>
                <p>
                  <strong>Lichtingskosten:</strong> Ja
                </p>
                <p>
                  <strong>Bedrag lichtingskosten:</strong>{" "}
                  {selectedInsurance.rescueAmount === "custom"
                    ? "Op aanvraag"
                    : `€ ${selectedInsurance.rescueAmount}`}
                </p>
              </>
            )}

            {/* Waterskiën */}
            {selectedInsurance.waterSkiing && (
              <>
                <p>
                  <strong>Waterskiën verzekerd:</strong> Ja
                </p>
                <p>
                  <strong>Waterski-capaciteit:</strong>{" "}
                  {selectedInsurance.waterskiCapacity || "—"}
                </p>
              </>
            )}

            {/* Casco + subopties */}
            {selectedInsurance.casco && (
              <>
                <p>
                  <strong>Casco verzekering:</strong> Ja
                </p>
                <p>
                  <strong>Casco waarde:</strong> €{selectedInsurance.cascoValue}
                </p>

                <p>
                  <strong>Trailer verzekerd:</strong>{" "}
                  {selectedInsurance.trailerInsurance ? "Ja" : "Nee"}
                </p>
                {selectedInsurance.trailerInsurance && (
                  <p>
                    <strong>Trailer waarde:</strong> €
                    {selectedInsurance.trailerValue}
                  </p>
                )}

                <p>
                  <strong>Bijboot verzekerd:</strong>{" "}
                  {selectedInsurance.dinghyInsurance ? "Ja" : "Nee"}
                </p>
                {selectedInsurance.dinghyInsurance && (
                  <p>
                    <strong>Bijboot waarde:</strong> €
                    {selectedInsurance.dinghyValue}
                  </p>
                )}

                <p>
                  <strong>Track & Trace aanwezig:</strong>{" "}
                  {selectedInsurance.trackAndTrace ? "Ja" : "Nee"}
                </p>
              </>
            )}

            {/* Ongevallen & Rechtsbijstand */}
            {selectedInsurance.personalAccidents && (
              <>
                <p>
                  <strong>Persoonlijke ongevallen:</strong> Ja
                </p>
                <p>
                  <strong>Aantal passagiers:</strong>{" "}
                  {selectedInsurance.accidentPassengers}
                </p>
              </>
            )}
            <p>
              <strong>Rechtsbijstand:</strong>{" "}
              {selectedInsurance.legalAssistance ? "Ja" : "Nee"}
            </p>
          </div>
        </div>

        {/* Navigatieknoppen */}
        <div className="flex justify-between mt-6 gap-4">
          <button
            type="button"
            onClick={handleBack}
            className="py-2 px-4 bg-[#1a2a6c] text-[#ff6f61] rounded-md text-sm font-medium hover:bg-[#142057]"
          >
            Gegevens wijzigen?
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="py-2 px-4 bg-[#1a2a6c] text-[#ff6f61] rounded-md text-sm font-medium hover:bg-[#142057]"
          >
            Bevestig hier je gegevens
          </button>
        </div>
      </div>

      <Modal show={showModal} onClose={handleCloseModal} />
    </div>
  );
};

export default ConfirmationPage;
